export default __webpack_public_path__ + "static/veracity-logo-white-5006d1baca4d35e06c4e8b3cdf1fc242.svg";